module.exports = __webpack_public_path__ + "img/full2-min.82e9c1a9.png";